import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import '../styles/Pages.css';

const Privacy = () => {
  return (
    <div className="page-container">
      <Header scrolled={true} />
      
      <main className="page-content">
        <section className="page-hero">
          <div className="container">
            <h1>Política de Privacidad</h1>
            <p>Última actualización: 24 de Febrero, 2026</p>
          </div>
        </section>
        
        <section className="page-section">
          <div className="container">
            <div className="legal-content">
              
              <div className="legal-section">
                <h2>1. Introducción y Rol de las Partes</h2>
                <p>En VillaTracking, respetamos su privacidad y nos comprometemos a proteger sus datos personales. Esta Política de Privacidad describe cómo recopilamos, utilizamos, procesamos y almacenamos su información cuando utiliza nuestros servicios de telemetría, rastreo GPS, sitio web y aplicaciones móviles.</p>
                <p><strong>Aviso Importante (Controlador vs. Procesador):</strong> Para nuestros clientes corporativos y empresariales, VillaTracking actúa estrictamente como <strong>Procesador de Datos</strong>. La empresa o particular que contrata nuestros servicios actúa como el <strong>Controlador de Datos</strong> y es exclusiva y legalmente responsable de informar y obtener el consentimiento de sus empleados, conductores o contratistas acerca de que los vehículos que operan están siendo monitoreados por GPS.</p>
              </div>
              
              <div className="legal-section">
                <h2>2. Información que Recopilamos</h2>
                <h3>2.1 Información Personal y de Cuenta</h3>
                <ul>
                  <li>Información de contacto (nombre, correo electrónico, número de teléfono).</li>
                  <li>Datos de facturación, suscripción e información fiscal.</li>
                  <li>Credenciales de acceso y logs de conexión a la plataforma.</li>
                </ul>
                
                <h3>2.2 Datos GPS y Telemetría de Vehículos (Datos Sensibles)</h3>
                <p>Dada la naturaleza de nuestro servicio de rastreo, recopilamos de forma automatizada y continua los siguientes datos generados por los dispositivos GPS vinculados a su cuenta:</p>
                <ul>
                  <li><strong>Ubicación Geográfica:</strong> Coordenadas exactas de latitud y longitud en tiempo real mientras el dispositivo esté activo.</li>
                  <li><strong>Historial de Trayectos:</strong> Rutas completas, eventos de creación y cruce de geocercas, paradas y tiempos de inactividad.</li>
                  <li><strong>Sensores y Telemetría:</strong> Velocidad de desplazamiento, estado del motor (encendido/apagado), voltaje de batería, desconexiones, alertas de impacto y pánico.</li>
                </ul>
              </div>

              <div className="legal-section">
                <h2>3. Cómo Utilizamos su Información</h2>
                <p>Utilizamos la información recopilada estrictamente para los siguientes fines:</p>
                <ul>
                  <li>Proporcionar, operar y mantener la plataforma de rastreo en tiempo real.</li>
                  <li>Generar reportes históricos y emitir notificaciones/alertas automatizadas a los usuarios designados por el cliente.</li>
                  <li>Brindar soporte técnico, procesar pagos y administrar suscripciones.</li>
                  <li>Detectar anomalías de seguridad, prevenir fraudes y asegurar la integridad de nuestros servidores.</li>
                  <li>Mejorar nuestros algoritmos de ubicación y rendimiento de mapas de manera agregada y anónima.</li>
                </ul>
              </div>
              
              <div className="legal-section">
                <h2>4. Compartición de Información a Terceros</h2>
                <p>VillaTracking no vende, alquila ni comercializa sus datos personales o historiales de ubicación. Solo compartimos la información estrictamente necesaria con las siguientes categorías de proveedores (Sub-procesadores) requeridos para el funcionamiento del servicio:</p>
                <ul>
                  <li><strong>Infraestructura y Nube:</strong> Proveedores de alojamiento (ej. AWS, Google Cloud, DigitalOcean) para el almacenamiento seguro de bases de datos.</li>
                  <li><strong>Proveedores de Cartografía:</strong> Motores de mapas (ej. Google Maps, Mapbox) utilizados para renderizar la interfaz cartográfica y realizar geocodificación. (Nota: Las coordenadas enviadas a estos proveedores son anónimas y no se asocian a placas de vehículos ni nombres de personas).</li>
                  <li><strong>Pasarelas de Pago:</strong> Proveedores financieros regulados (ej. Stripe, PayPal) para el procesamiento seguro de transacciones. No almacenamos datos completos de tarjetas de crédito en nuestros servidores.</li>
                </ul>
              </div>

              <div className="legal-section">
                <h2>5. Privacidad de Menores de Edad</h2>
                <p>Nuestros servicios de telemetría y gestión de flotas están diseñados y dirigidos exclusivamente a uso comercial, empresarial y para personas mayores de edad. No recopilamos intencionadamente información de menores de 18 años. Si descubrimos que hemos recopilado información de un menor sin consentimiento parental o legal, procederemos a la eliminación inmediata de dichos datos.</p>
              </div>

              <div className="legal-section">
                <h2>6. Retención y Eliminación de Datos</h2>
                <p>Nuestras políticas de retención buscan equilibrar la necesidad operativa con la protección a la privacidad:</p>
                <ul>
                  <li><strong>Historial de Rutas y Alertas:</strong> Conservamos la información de telemetría de su flota por un periodo estándar de tiempo (generalmente entre 3 a 12 meses, dependiendo de su plan contratado). Superado este periodo, los datos se eliminan automáticamente o se anonimizan permanentemente para fines estadísticos.</li>
                  <li><strong>Cancelación de Cuenta:</strong> Si usted solicita la cancelación de sus servicios o eliminación de cuenta, sus datos personales y el historial de ubicaciones completo serán eliminados de nuestras bases de datos operativas en un plazo no mayor a 30 días, conservando únicamente la documentación obligatoria exigida por normativas fiscales o legales vigentes.</li>
                </ul>
              </div>

              <div className="legal-section">
                <h2>7. Seguridad de los Datos</h2>
                <p>Implementamos medidas técnicas, organizativas y físicas rigurosas para proteger su información contra accesos no autorizados, pérdidas, destrucción o alteraciones. Esto incluye encriptación de contraseñas, protocolos seguros de transferencia de datos (HTTPS/SSL/WSS) y barreras de acceso en nuestras bases de datos.</p>
              </div>

              <div className="legal-section">
                <h2>8. Sus Derechos</h2>
                <p>Usted tiene derecho a consultar, rectificar, exportar (portabilidad) o solicitar la eliminación de su información personal y los datos de su cuenta almacenados en nuestra plataforma. Para ejercer estos derechos, el titular de la cuenta debe enviar una solicitud formal a nuestro equipo de soporte.</p>
              </div>

              <div className="legal-section">
                <h2>9. Transferencias Internacionales</h2>
                <p>Los datos de telemetría y su información personal pueden ser alojados, transferidos y procesados en servidores ubicados en países distintos al de su residencia (por ejemplo, en centros de datos ubicados en Estados Unidos o Europa). Al utilizar VillaTracking, usted otorga su consentimiento expreso para esta transferencia, respaldada bajo estándares modernos de protección en la nube.</p>
              </div>
              
              <div className="legal-section">
                <h2>10. Cambios a esta Política</h2>
                <p>Nos reservamos el derecho de modificar esta Política de Privacidad para reflejar actualizaciones legales, operativas o tecnológicas. Si realizamos cambios sustanciales, se lo notificaremos publicando una actualización en esta página o enviándole un aviso directo a través de nuestra plataforma o correo electrónico.</p>
                <p>Le recomendamos revisar esta Política de Privacidad periódicamente.</p>
              </div>
              
              <div className="legal-section">
                <h2>11. Contacto</h2>
                <p>Si tiene inquietudes sobre esta Política de Privacidad, requerimientos legales o preguntas sobre cómo protegemos la telemetría de su flota, no dude en contactarnos a:</p>
                <p><strong>Email:</strong> soporte@villatracking.com</p>
                <p><strong>Dirección:</strong> Los Laureles, Cabimas 4013, Estado Zulia, Venezuela</p>
              </div>

            </div>
          </div>
        </section>
      </main>
      
      <Footer />
    </div>
  );
};

export default Privacy;